const LeagueNameLink = (leagueRow:any) => (<a className='text-blue-800 underline' href={`/season/${leagueRow.metadata.seasonId}/league/${leagueRow.leagueId}`}>{leagueRow.metadata.name}</a>);

export default LeagueNameLink;